import {IOdds, IOddsObj, IProvider} from "./types";

export const getUniqueProviders = (oddsArr: IOdds[][]): IProvider[] => {
  const providers: IProvider[] = [];

  // Extract all Providers
  oddsArr.forEach((oddsArrItem: IOdds[]) => {
    oddsArrItem.forEach((odds: IOdds) => {
      if (odds.provider && !providers.find(provider => provider.id === odds.providerId)) {
        providers.push(odds.provider)
      }
    })
  })

  return providers
}

export const sortProvidersByIds = (providers: IProvider[], orderedProviderIds: number[]): IProvider[] => {
  if (!orderedProviderIds || !providers) {
    return providers;
  }

  const orderedProviders: IProvider[] = [];
  orderedProviderIds.forEach(orderedProviderId => {
    const provider: IProvider|undefined = providers.find((provider: IProvider) => provider.id === orderedProviderId);
    if (provider) {
      orderedProviders.push(provider)
    }
  })

  return orderedProviders
}

export const getOddsClassName = (odds: IOdds | IOddsObj | null): string => {
  if (!odds || !odds.oddsPrev || (odds.odds === odds.oddsPrev)) {
    return '';
  }

  return odds.odds as number > odds.oddsPrev ? 'shortening' : 'drifting';
}

// Returns height in pixels for loading block
export const getLoadingBlockHeight = (
  listRangeFrom: null | number,
  listRangeTo: null | number,
  isMobile: boolean,
): number => {
  // Validation
  if (!listRangeTo || listRangeTo < 1) {
    return isMobile ? 315 : 350;
  }

  // Default component height (in pixels)
  const allComponentSizes = {
    desktop: {
      emptyComponentHeight: 41, // Table header height
      contentMinHeight: 0,
      competitorRowHeight: 52,
    },
    mobile: {
      emptyComponentHeight: 31, // Table header height
      contentMinHeight: 69,
      competitorRowHeight: 38,
    },
  }

  const componentSizes = isMobile ? allComponentSizes.mobile : allComponentSizes.desktop;
  const startIndex: number = listRangeFrom && listRangeFrom > 0 ? listRangeFrom - 1 : 0;
  const rowCount = listRangeTo - startIndex;

  // Calculation
  const loadingBlockHeight: number = componentSizes.emptyComponentHeight + (rowCount * componentSizes.competitorRowHeight);

  return componentSizes.contentMinHeight > loadingBlockHeight
    ? componentSizes.contentMinHeight
    : loadingBlockHeight
}
